import { AnimationsEnum } from "../constants/talkingHead";

export const getRandomAnimation = (animationArray: AnimationsEnum[]) => animationArray[Math.floor(Math.random() * animationArray.length)];
